<template>
  <div class="row">
    <div class="sesson_group">
      <div class="sesson_detail">
        <div class="col-12">
          <div class="sesson_detail_title">
            <div class="sesson_detail_title_left"><a @click="backUrl"><i class="fa fa-play-circle"/> Quay lại</a></div>
            <div class="sesson_detail_title_right"><a href="#"><span class="btn_error">Báo lỗi</span> <i
              class="fa fa-chevron-right"/></a></div>
          </div>

          <div class="sesson_detail_video">
            <Media
              :kind="'video'"
              :controls="true"
              :autoplay="true"
              :src="[video_url]"
              style="z-index: 50; width: 100%; height: auto; min-height: 240px;position: relative"/>
          </div>
          <div class="sesson_detail_title">
            <div class="sesson_detail_title_left"><a href="#"><span class="btn_auto_loading">Tự động chạy </span> </a>
            </div>
            <div class="sesson_detail_title_right"><a href="#">Bài tiếp <i class="fa fa-step-forward"/></a></div>
          </div>
        </div>
      </div>

      <div class="sesson_body">
        <nav class="tab-nav w-100">
          <div
            id="nav-tab"
            class="nav nav-tabs"
            role="tablist">
            <a
              id="nav-home-tab"
              class="nav-item nav-link active"
              data-toggle="tab"
              href="#nav-home"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">Giáo trình</a>
            <a
              id="nav-profile-tab"
              class="nav-item nav-link"
              data-toggle="tab"
              href="#nav-profile"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false"
              @click="loadComments()">Thảo luận</a>
          </div>
        </nav>
        <div
          id="nav-tabContent"
          class="tab-content">
          <div
            id="nav-home"
            class="tab-pane fade show active"
            role="tabpanel"
            aria-labelledby="nav-home-tab">
            <div class="list-sesson">
              <div
                v-for="group in groups"
                v-if="groups && groups.length > 0"
                class="list-sesson-group">
                <div class="list-sesson-group-name">{{ group.description }}</div>

                <div
                  v-for="lesson in group.lessons"
                  v-if="group.lessons && group.lessons.length > 0"
                  class="list-sesson-group-round"
                  @click="playVideo(lesson.id)">

                  <div class="list-sesson-group-detail">
                    <div class="list-sesson-group-detail-icon">
                      <i class="fa fa-check"/>
                    </div>
                    <div class="list-sesson-group-detail-name">{{ lesson.name }}</div>
                    <div class="list-sesson-group-detail-type">
                      <span
                        v-if="lesson.free_view === 1"
                        class="bg-green text-white">Xem miễn phí</span>
                      <span
                        v-if="lesson.free_view !== 1"
                        class="bg-defaut text-white">Mua khóa học</span>
                    </div>
                    <div class="list-sesson-group-time">{{ lesson.duration }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="nav-profile"
            class="tab-pane fade"
            role="tabpanel"
            aria-labelledby="nav-profile-tab"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import ApiConfig from '../../communicate/ApiConfig'
  import {errorToaster, infoToaster, warnToaster} from '../../services/ErrorHandler'
  import Media from '@dongido/vue-viaudio'
  import {isLoggedIn} from '../../services/authService'

  export default {

    name: 'Lesson',

    components: {
      Media
    },

    // eslint-disable-next-line vue/require-prop-types
    props: ['item'],

    data: function () {
      return {
        base_url: ApiConfig.base_url,
        lesson: {},
        comments: [],
        course_name: '',
        lessons: [],
        id: this.$route.params.id,
        course_id: this.$route.query.course_id,
        course: {},
        groups: [],
        video_url: '',
        total_lessons: []
      }
    },

    watch: {
      $route (to, from) {
        this.getDetailLesson(to.params.id);
      }
    },

    mounted () {
      this.getDetailLesson(this.id);
      this.loadCourseById(this.course_id);
    },

    methods: {
      getDetailLesson (id) {
        rf.getRequest("LessonRequest").getDetailLesson(id).then((res) => {
          if (res.status === 200) {
            this.lesson = res.data.lesson;
            this.video_url = res.data.lesson.lesson_url;
            this.comments = res.data.comments;
            this.course_name = res.data.course;
            this.lessons = res.data.lessons;
          } else {
            if (res.status === 401 || res.status === 403) {
              this.$router.push("/login");
            } else {
              infoToaster("Cố vấn phong thủy", "Bạn cần mua khóa học để được tiếp tục xem");
            }
          }
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", err.message);
        })
      },

      loadCourseById (course_id) {
        rf.getRequest('CourseRequest').getCourseDetail(course_id).then(res => {
          this.courses = res.data.course
          this.groups = res.data.groups
          if (this.groups && this.groups.length > 0) {
            for (let i = 0; i < this.groups.length; i++) {
              let lessons = this.groups[i].lessons;
              if (lessons && lessons.length > 0) {
                lessons.forEach(les => {
                  this.total_lessons.push(les);
                })
              }
            }
          }
        }).catch(err => {
          warnToaster(err.message);
        })
      },

      playVideo (lesson_id) {
        if (this.isCanViewLesson(lesson_id)) {
          this.getDetailLesson(lesson_id);
        } else {
          if (isLoggedIn()) {
            this.getDetailLesson(lesson_id);
          } else {
            infoToaster("Cố vấn phong thủy", "Bạn cần login để tiếp tục với bài giảng này");
          }
        }
      },

      isCanViewLesson (lesson_id) {
        this.total_lessons.forEach(less => {
          if (less.id === lesson_id) {
            if (less.free_view === 1) {
              return true;
            } else {
              return false;
            }
          }
        })
      },

      loadComments () {
        //TODO: need to load comment
      },

      backUrl () {
        window.history.back();
      }
    }
  }
</script>

<style scoped>
  .bg-green {
    background: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/course/Lesson.vue